<template>
  <div id="app">
    <Header/>
    <router-view />
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
export default {
  components:{Header,Footer},
  name: 'App',
}
</script>

<style>
@import url('./index.css');
/*  p
  {
      font-family:'m';
  } */
 html,body{
   min-width: 1500px;
 }
.fk{
  width: 20px;
  height: 20px;
  background: #F90103;
}
 .flex{
   display: flex;
   justify-content: space-between;
 }
.fc-12{
    font-size: 12px;
    color: #808080;
    line-height: 1.8;
}
button,input{
  border: none;
  outline: none;
}
img,span{
  vertical-align: top;
}
div{
  box-sizing: border-box;
  vertical-align: top;
}
*{
  margin: 0;
  padding: 0 ;
}
ul{
  list-style: none;
}



.index_top_h1{
  text-align: center;
}
.index_top_h1 p:nth-of-type(1){
  font-size: 40px;
}
.index_top_h1 p:nth-of-type(2){
  font-size: 30px;
}
.index_top_pp{
  width: 50px;
  height: 1px;
  background: #ccc;
  border-radius: 1px;
  margin-top: 10px;
}
.index_top_pp span{
  display: inline-block;
  height: 1px;
  width: 50%;
  background: #FFFFFF;
}
.index_top_p{
  width: 38px;
  line-height: 38px;
  height: 38px;
  text-align: center;
  background: #FA3435;
  color: #FFFFFF;
  border-radius: 50%;
}
.index_center_11_1 button{
  width: 20%;
  padding: 10px 0;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  background: transparent;
  color: #E6E6E6;
}
.index_center_11_1>div:nth-of-type(1){
  font-size: 26px;
  display: flex;
  border-bottom: 1px dotted #E6E6E6;
  justify-content: center;
  align-items: center;
}
.index_center_11_1{
  width: 40%;
  margin: 0 auto;
  text-align: center;
}
.index_center_10_1>img{
  width: 30%;
}
.index_center_11{
  /* background: url(./image/Cooperationcase/合作案例banner图.png) no-repeat; */
  /* background-size:100% 100% ; */
  /* height: 320px; */
  position: relative;
}
.index_center_11>div{
  height: 100%;
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  /* background: rgba(0,0,0,.5); */
  display: flex;
  align-items: center;
}
.index_center_10_1_2{
  width: 50%;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #808080;
  cursor: pointer;
}
.index_center_10_1_3{
  width: 100%;
}
.index_center_10_1_2 div{
  margin-left: 10px;
}
.index_center_8_4{
  height: 36%;
  width: 100%;
}
.index_center_10>div{
  display: flex;
}
.index_center_10_1_1 p:nth-of-type(1){
  font-size: 20px;
}
.index_top_h1 span{
  opacity: 0.8;
}
.index_center_10_1_1 p:nth-of-type(2){
  color: #4D4D4D;
  font-size: 19px;
}
.index_center_10_1>div:nth-of-type(3){
  width: 30%;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.index_center_10_1>div:nth-of-type(1){
  width: 40%;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.index_center_7{
  padding-bottom: 50px;
}
.index_center_9>p{
  color: #808080;
  width: 60%;
  line-height: 1.8;
  font-size: 12px;
}

.index_center_9>div p:nth-of-type(1){
  color: #333333;
  font-size: 18px;
  font-weight: bold;
}
.index_center_9>div p:nth-of-type(2){
  color: #4D4D4D;
  font-size: 19px;
  margin: 10px 0;
}
.index_center_9 button{
  width: 122px;
  height: 42px;
  line-height: 42px;
  border-radius: 5px;
  background: #FA3435;
  color: #FFFFFF;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}
.index_center_9 button:active{
  transform: scale(0.8);
}
.index_center_9>div{
  display: flex;
  justify-content: space-between;
  height: 100px;
  align-items: center;
}
.index_center_9{
  border-bottom: 1px solid #808080;
  padding: 30px 20px;
}
.index_center_8_3{
  /* margin-top: 223px; */
  /* margin-top:40% ; */
}
.index_center_8_2{
  /* height: 223px; */
  height: 33%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #4D4D4D;
  padding-left: 30px;
  width: 100%;
  cursor: pointer;
}
.index_center_8_2 p:nth-of-type(1){
  font-size: 18px;
  color: #050505;
  font-weight: bold;
}
.index_center_8_2 p:nth-of-type(2){
 font-size: 19px;
 color: #808080;
 margin: 10px 0 30px 0;
}
.index_center_8_2 p:nth-of-type(3){
    width: 15%;
    height: 1px;
    background: #FA3435;
}
.index_center_8_1{
  /* position: absolute; */
  /* right: 0; */
  box-sizing: border-box;
  /* height: 223px; */
  height: 36%;
  align-items: center;
  display: flex;
  padding-left: 30px;
  background: #FA3435;
  width: 100%;
}
.indexActive p:nth-of-type(3){
  background: #FFFFFF!important;
}
.indexActive p{
  color: #FFFFFF!important;
}
.indexActive{
  opacity: 0.8;
  background: #FA3435;
  width: 150%;
}
.index_center_8_1 p:nth-of-type(1){
    font-size: 18px;
    color: #FFFFFF;
}
.index_center_8_1 p:nth-of-type(2){
    font-size: 14px;
    color: #FFFFFF;
    margin: 10px 0 30px 0;
}
.index_center_8_1 p:nth-of-type(3){
    width: 15%;
    height: 2px;
    background: #FFFFFF;
}
.index_center_8>div:nth-of-type(1){
  width: 74%;
}
.index_center_8>div:nth-of-type(2){
  width: 26%;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: flex-end;
  z-index: 10;
  justify-content: space-between;
}
.index_center_8>div:nth-of-type(1) img{
  width: 100%;
}
.index_center_8{
  display: flex;
  position: relative;
}
.index_center_7>div:nth-of-type(1){
  width: 50%;
  margin: 60px auto;
  /* border-bottom: 1px solid #2C2B2A; */
  text-align: center;
  box-sizing: border-box;
  position: relative;
}
.index_center_7>p{
  color: #808080;
  font-size: 14px;
  margin-bottom: 10px;
}
.index_center_7>div:nth-of-type(1)>p:nth-of-type(1){
  color: #4D4D4D;
  font-size: 19px;
}
.index_center_7>div:nth-of-type(1)>p:nth-of-type(2){
  color: #333333;
  font-size: 29px;
  margin: 2px 0 10px 0;
}
.index_center_7>div:nth-of-type(1)>p:nth-of-type(3){
  height: 1px;
  width: 6%;
  margin: 0 auto;
  background-color: #2C2B2A;
  position: absolute;
  bottom: 0px;
  left: 47%;
  /* vertical-align: bottom; */
  /* display: inline-block; */
}
.index_center_7>div:nth-of-type(1)>p:nth-of-type(4){
  height: 1px;
  width: 100%;
  /* background-color: #2C2B2A; */
  border-bottom: 1px dotted #2C2B2A;
  /* vertical-align: bottom; */
  /* display: inline-block; */
}
.index_center_6{
  width: 20px;
  height: 20px;
  background: #F90103;
  margin: 60px 0;
}
.index_center_5>div{
   width: 24%;

}
.index_center_5>div>p:nth-of-type(1){
  font-size: 14px;
  color: #333333;
  margin-top: 30px;
}
.index_center_5>div>p:nth-of-type(2){
  font-size: 20px;
  color: #4D4D4D;
  /* margin-top:10px ; */
  font-weight: bold;
  letter-spacing: 2px;
}
.index_center_5>div>p:nth-of-type(3){
  font-size: 13px;
  color: #808080;
  line-height: 1.8;
}
.index_center_5>div>span{
  display: inline-block;
  width: 70%;
  height: 1px ;
  background: #808080;
}
.index_center_5{
  display: flex;
  justify-content: space-between;
  text-align: right;
}
.index_center_5>div>div:nth-of-type(1){
  text-align: right;
  margin-bottom: 20px;
}
.index_center_5 img{
  width: 100%;
  border-radius: 10px;
}

.index_center_5>div>div:nth-of-type(1)>span:nth-of-type(1){
    border-bottom: 2px dotted #808080;
    display: inline-block;
    height: 2px;
    width: 60%;
}
.index_center_5>div>div:nth-of-type(1)>span:nth-of-type(2){
    background: url('./image/index/圆点装饰.png') no-repeat;
    background-size: 100% 100%;
    width: 34px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    color: #FFFFFF;
    text-align: center;
    vertical-align: top;
}
.index_center_4>div:nth-of-type(2)>p:nth-of-type(1){
    font-size: 42px;
    color: #333333;
    text-align: right;
}
.index_center_4 img{
  vertical-align: middle;
}
.index_center_4 span{
  vertical-align: middle;
  margin: 0 20px;
}
.index_center_4>div:nth-of-type(2)>p:nth-of-type(2){
  font-size: 28px;
  color: #808080;
  text-align: right;
}
.index_center_4>div:nth-of-type(1) span{
    font-size:  30px;
    color: #333333;
    letter-spacing: 10px;
}
.index_center_4{
  margin-bottom: 70px;
}
 .index_center_3{
   text-align: right;
   margin: 30px 0;
 }
.index_center_3 span{
    display: inline-block;
    width: 20px;
    height: 20px;
    background: #F90103;
}
.index_center_2{
  margin-top: 120px;
  text-align: right;
  color: #808080;
  font-size: 20px;
}
.index_center_2 span{
  display: inline-block;
  width: 60%;
  height: 1px;
  background: #808080;
}
.index_center_1>div:nth-of-type(1)>div{
  display: flex;
  justify-content: space-between;
  /* padding-top: 40px; */
  padding-right: 40px;
  box-sizing: border-box;
}
.index_center_1>div:nth-of-type(1)>div>div:nth-of-type(2)>p:nth-of-type(1){
  color: #4D4D4D;
  font-size: 24px;
  text-align: right;
  margin-top:20px;
}
.index_center_1>div:nth-of-type(1)>div>div:nth-of-type(2)>p:nth-of-type(2){
  color: #333333;
  font-size: 24px;
  font-weight: bold;
  text-align: right;
  margin-top: 10px;
}
.index_center_p{
  text-align: right;
  font-size: 13px;
  color: #808080;
  line-height: 1.8;
  margin-top: 20px;
  padding-right: 40px;
  box-sizing: border-box;
}
.index_center_1{
  position: relative;
  z-index: 9;
}
.index_center_1 button{
    width: 122px;
    height: 42px;
    line-height: 42px;
    border-radius: 5px;
    color: #FFFFFF;
    font-size: 14px;
    cursor: pointer;
    background: #FA3435;
    transition: all 0.2s;
    /* margin-top: 10px; */
}
.index_center_1 button:active{
   transform: scale(0.8);
}
.index_top{
  position: relative;
 }
.index_top img{
  width: 100%;
}
.index_top>div{
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,.5);
  z-index: 2;
}
.index_top>div>div{
  width: 70%;
  margin: 0 auto;
}
.index_top_1{

  display: flex;
  justify-content: space-between;
   width: 70%;
   color: #FFFFFF;
   font-size: 16px;
   align-items: center;
}
.index_top_1 img{
  width: 30px;
  margin: 0 15px;
  vertical-align: middle;
  cursor: pointer;
}
.index_center_1{
  display: flex;

}
.index_top_1 span{
  opacity: 0.6;
}
.index_center_1>div:nth-of-type(1){
  width: 70%;
  border-bottom: 1px solid #808080;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.index_center_1>div:nth-of-type(2){
  width: 30%;
}
.index_center_1>div:nth-of-type(2) img{
  width: 100%;
}
.index_center{
  width: 70%;
  margin: 0 auto;
}
.cooperation_center_1_1>div{
  width: 31%;
  background: #FFFFFF;
  border-radius: 10px;
  overflow: hidden;
  padding-bottom: 20px;
  margin-bottom: 60px;
  transition: all 0.5s;
}
p{
  line-height: 1.6;
}
.cooperation_center_1_1>div:hover{
  box-shadow: 0px 0px 17px 8px #CCCCCC;
}
.cooperation_center_1_1>div:nth-of-type(2),.cooperation_center_1_1>div:nth-of-type(3),.cooperation_center_1_1>div:nth-of-type(5){
  margin-left: 2%;
}
.cooperation_center_1_1>div p:nth-of-type(1){
  font-size: 20px;
  color: #333333;
}
.cooperation_center_1_1>div p:nth-of-type(2){
  font-size: 12px;
  color: #333333;
}
.cooperation_center_1_1{
  display: flex;
  flex-wrap:wrap ;
}
.cooperation_center_1_1>div span{
  display: block;
  width: 40px;
  height: 1px;
  border-radius: 2px;
  background-color: #F90103;
  margin: 10px 0;
}
.cooperation_top>div{
  /* background: rgba(0,0,0,.7); */
}
.cooperation_center_1{
  margin-top: 120px;
}
.cooperation_center{
  width: 70%;
  margin: 0 auto;
  padding-bottom: 20px;
}
.cooperation_ban_bot{
  position: absolute;
  bottom: 20px;
  right: 0;
}
.cooperation_ban_bot span{
  display: inline-block;
  width: 30px;
  height: 1px;
  background: #FFFFFF;
}
.cooperation{
  background: #F2F2F2;
}
.cooperation_top_1{
      position: absolute;
      top: 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      color: #FFFFFF;
      font-size: 16px;
      align-items: center;
      z-index: 9;
}
.business_center_7{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.business_center_7 p:nth-of-type(1){
  font-size: 30px;
  color: black;
}
.business_center_7 p:nth-of-type(2){
  font-size: 24px;
  color: #808080;
}
.business_center_6_6_1{
      width: 73%;
      margin-left: 19%;
}

.business_center_6_4{
  width: 100%;
  position: relative;
}

.business_center_6>div{
  margin-bottom: 80px;
}
.business_center_6_2_sp{
  position: absolute;
  right: 0;
  top: 0;
}
.business_center_6_2_sp1{
  position: absolute;
  right: auto;
  left: 0;
  top: 0;
}
.business_center_6_2_sp1 p:nth-of-type(1){
     width: 180px;
         height: 1px;
         background: #333333;

}
.business_center_6_2_sp1 p:nth-of-type(2){
      width: 1px;
      height: 70px;
      background: #333333;
}
.business_center_6_2_1>span{
  width: 100px;
  height: 5px;
  background: #F90103;
  display: inline-block;
}
.business_center_6_2_1{
  margin-left:14%;
  width: 76%;
}
.business_center_6_2{
  text-align: right;
}
.business_center_6_2_sp>span:nth-of-type(1){
  width: 180px;
  display: inline-block;
  height: 1px;
  background: #333333;
  vertical-align: top;
  position: relative;
  right: -5px;
}
.business_center_6_2_sp>span:nth-of-type(2){
  width: 1px;
  display: inline-block;
  height: 70px;
  background: #333333;
}
.business_center_6_1{
  /* text-align: right; */
  position: relative;
  color:#FFFFFF;
}

.business_center_6_1>div{
  background: #171717;
  opacity: 0.8;
  border-radius: 20px;
  width: 151px;
  position: absolute;
  top: -40px;
  left: 0;
  padding: 13px 20px 13px 0;
  text-align: right;
}
.business_center_6_3>div{
  position: absolute;
  top: -40px;
  right: 0;
  left: auto;
}
.business_center_6_1 p:nth-of-type(1){
    font-size: 22px;
}
.business_center_6_1 p:nth-of-type(2){
    font-size: 12px;
    margin-top: 10px;
}
.business_center_6_1 span{
  display: inline-block;
  width: 20px;
  height: 2px;
  background: #FFFFFF;
  margin: 20px 0;
}
.business_center_6>div>div{
  width: 50%;
  /* position: relative; */
}
.business_center_5>span{
  display: block;
  width: 40%;
  height: 1px;
  background: #808080;
  margin: 30px 0;
  border-radius: 1px;
}
.business_center_5{
  position: relative;
  padding-top: 80px;
}
.business_center_5_img{
  position: absolute;
  width: 80%;
  left: 2%;
  top: 50px;
}
.business_center_4{
  width: 6%;
  height: 1px;
  background: #808080;
  opacity: 0.36;
  border-radius: 1px;
  display: block;
}
.business_center_3{
  text-align: right;
  margin: 40px 0;
}
.business_center_2{
  position: absolute;
  right: 10px;
  bottom: 20px;
}
.business_center_1{
  width: 26%;
  position: relative;
  height: 174px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  cursor: pointer;
}
.business_center_1>img{
  position: absolute;
  right: 10px;
  top: 10px;
}
.business_center_1>span{
  width: 40px;
  height: 1px;
  background: #4B4A4A;
  position: absolute;
  right: 10px;
  top: 10px;
}
.business_center{
  width: 70%;
  margin:0 auto;
  margin-top: 30px;
}
.business_top_h1{
  position: relative;
}
.business_top_h1>div{
  position: absolute;bottom: 20px;left: 0;
  font-size: 13px;
}
.business_center_6_5{
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  width: 100%!important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.business_center_6_6{
   position: relative!important;
   top: 0%!important;
   width: 40%!important;
   height: 120%;
   border-radius: 0!important;
   background: #FA3435!important;
   opacity: 0.65!important;
   display: flex;
   align-items: center;
}
.business_center_6_6_1 span{
      width: 100px;
      height: 5px;
      background: #FFFFFF;
      display: inline-block;
}
.about2{
  width: 70%;
  margin: 0 auto;
}
.about3>div{
    position: absolute;
    width: 100%;
    height: 100%;
    /* background: rgba(0,0,0,.6); */
    top: 0;
    left: 0;
}
.about3>div>div{
  width: 60%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  text-align: center;
  color: #ffffff;
}
.about1_1{
  width: 70%;
  margin: 0 auto;
}
.about1{
  margin-top: 20px;
  padding: 30px 0;
  background: #fafafa;
}
.about_center_2_2_2_2_span{
  width: 30px;
  height: 2px;
  background: #f90103;
  display: inline-block;
  margin-top: 10px;
}
.lineSpan{
  display: block;
  width: 40%;
  height: 1px;
  background: #8a8a8b;
  margin-top: 40px;
}
.about_center_2_2_2_4_1{
  border-bottom: 1px dotted #999694;
  padding-bottom:5px ;
}
.about_center_2_2_2_4{
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.about_center_2_2_2_4>div:nth-of-type(1){
  width: 120px;
  height: 120px;
  border: 3px solid #ffffff;
  border-radius: 50%;
  margin-right: 8%;
}
.about_center_2_2_2_4>div:nth-of-type(2)>div{
  margin-top: 13px;
}
.about_center_2_2_2_3{
  height: 86%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.about_center_2_2_2_2{
  /* align-items: center; */
  width: 100%;
}
.about_center_2_2_2_1{
  position: absolute;
  width: 100%;
  height: 100%;
  /* background: rgba(0,0,0,.6); */
  top: 0;
  left: 0;
  /* padding: 0 20px; */
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
}
.about_center_2_2_2{
  position: relative;
}
.about_center_2_2_1{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 40px;
}
.about_center_2_2_1 p{
  width: 60%;
  text-align: right;
  color: #808080;
  border-bottom: 1px solid  #808080;
}
.about_center_2_2{
  margin-top:  150px;
}
.about_center_2_1 li{
  margin: 10px 0;
  width: 30px;
  line-height: 30px;
  height: 30px;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
}
.ABborAC{
  border: 1px dotted #F90103;
  color: #F90103;
}
.Abbor{
  font-weight: bold;
}
.Abbor1{
  font-weight: bold;
  color: #FFFFFF;
}

.about_center_2_1{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.business_center_5{
  width: 75%;
}
 .business_center_5>span>span{
   width: 10%;
   height: 2px;
   display: inline-block;
   background: #F90103;
 }
.about_center_5_img{
  position: absolute;
  width: 63%;
  left: 8%;
  top: 50px;
}
.about_center_2{
  width: 70%;
  margin: 0 auto;
}
.about_center_1_1{
  align-items: center;
  width: 86%;
  margin: 0 auto;
}
.about_center_1_2{
  align-items: center;
  width: 86%;
  margin: 0 auto;
}
.about_center_1_2>div{
  width: 98px;
  text-align: center;
  font-size: 14px;
  color: #151618;
  margin-top: 10px;
}
.bgcolor{
  background: #151618;
}
.about_center_1{
  padding:  50px 0;
  background: #FAFAFA;
}
.about_center_1_1>div{
  width: 98px;
  height: 98px;
  line-height: 98px;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
}
.about_center_1 img{
  vertical-align: middle;
}
.about_center_1>div{
  width: 70%;
  margin: 0 auto;
}
.about_top_1{position: absolute;
    bottom: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #FFFFFF;
    font-size: 16px;
    align-items: center;
    z-index: 9;
}
.about_top_h1>div{
      position: absolute;
      top: 20px;
      left: 0;
      font-size: 13px;
}
.wt_70{
  width: 70%;
  margin: 0 auto;
}
.cor_14{
      color: rgb(51, 51, 51);
      margin-top: 10px;
      font-size: 14px;
}
.cooperationA_content_5_1{
  width: 100%!important;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  flex-direction: row!important;
  align-items: center;
}
.cooperationA_content_5{
  padding: 30px 0 80px 0;
  background-color: #FAFAFA;
}
.cooperationA_content_3_12{
    position: absolute;
    width: 94%;
    height: 100%;
    top: 0;
    left: 3%;
    align-items: center;
}
.cooperationA_content_3_11{
  position: absolute;
  right: 0;
  top: 20px;
}
.cooperationA_content_4{
  background: #302F2E;
  padding: 50px 30px 40px 30px;
}
.cooperationA_content_3_ul {
    width: 30%;
    display: flex;
    justify-content: space-between;
}

.cooperationA_content_1_2_3_img{
  position: absolute;
  width: 45%;
  top: -5%;
}
.cooperationA_content_3{
  background: #FAFAFA;
  padding: 80px 0 10px 0;
}
.cooperationA_content_1_2_3{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.cooperationA_content_1_2_2>p:nth-of-type(1){
  width: 30px;
  height: 2px;
  background: #FA3435;
}
.cooperationA_content_1_2_1{
  width: 90%;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.cooperationA_content_1_2{
  position: relative;
}
.cooperationA_content_1_21{
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  /* background: rgba(0,0,0,.6); */
}
.cooperationA_content_1{
  background-color: #FAFAFA;
 /* padding-bottom: 110px;
  padding-top: 100px; */
}
.cooperationA_content_2{
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}
.cooperationAAC{
  opacity: 0.2;
}

.cooperationA_content_2>p{
  position: relative;
  padding: 8px 5px;
  color: #FFFFFF;
  background: #FA3435;
  font-size: 13px;
  background: url('./image/index/bg.png') no-repeat;
  background-size: 100% 100%;
  border-radius: 2px;
}
.cooperationA_content_2>div{
    background: #FA3435;
    width: 50px;
    height: 50px;
    line-height: 50px;
    margin-left: 2px;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
}
.cooperationA_content_2>div img{
  vertical-align: middle;
}

.contact .el-carousel__container{
  height: 260px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue